export default {
  menuTree: [],
  menuIdMap: {},
  menuUrlMap: {},
  actionPermissionMap: {},
};
